import { render, staticRenderFns } from "./OnlineTestItem.vue?vue&type=template&id=64475a7c"
import script from "./OnlineTestItem.vue?vue&type=script&lang=js"
export * from "./OnlineTestItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports